import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';
import {Typography} from "@mui/material";
import DialogButtonRegistration from "../../components/DialogButtonRegistration/DialogButtonRegistration";

const ProductPage: React.FC = () => {

    return(
        <>
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '80vh',
                }}
            >
                <Box sx={{ maxWidth: 800, margin: '0 auto', padding: 2 }}>
                    <Grid container spacing={{ xs: 2, md: 3 }}>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}  >
                            <Typography variant="h2" gutterBottom>
                                Продукт
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}  >
                            <DialogButtonRegistration streamName={'product'} />
                        </Grid>
                    </Grid>

                    <Typography variant="body1" paragraph>
                        Необходимо создать продукт, который потом продавать B2C или B2B.
                    </Typography>
                    <Typography variant="body1">
                        В чём ключевое отличие: вы 1 раз делаете продукт или аналитику - и поддерживаете их в актуальном состоянии - а их у вас все покупают.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Т.е. у вас не кастомная разработка под каждого клиента, а вы 1 раз сделали - потом продали нескольким людям или компаниям.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Это может быть и сайт с покупкой лицензии/подписки на сайте и автоматической её обработкой, и канал на бусти, куда вы собираете и выкладываете какую-то аналитику, а люди вам потом за платный доступ к ней платят - и что угодно по похожей схеме.
                    </Typography>

                    <div>
                        <Typography variant="body1" paragraph>
                            Оценка будет по следующим факторам:
                        </Typography>
                            <ul>
                                <li>Масштабируемость: потенциально можно бесконечно масштабировать без роста штата или в одного.</li>
                                <li>Востребованность - желательны реальные продажи.</li>
                                <li>Потенциальная возможность настроить unit-экономику - клиент за время жизни приносит достаточно, чтобы окупились затраты на его привлечение + налоги + затраты на операционную деятельность.</li>
                                <li>Оригинальность идеи. 20 различных вариантов телеграмм ботов, которые парсят сайт с вакансиями - такое себе.</li>
                                <li>Экономическая модель - проект должен быть прибыльным.</li>
                                <li>Маркетинг: находки по привлечению клиентов тоже приветствуются.</li>
                            </ul>
                    </div>

                </Box>
            </Box>
        </>
    )
}

export default ProductPage;